import {
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { ModalSettings } from "~app/common/components/modal/modal-models";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ToastService } from "~app/common/components/toast/toast.service";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { RaskCommonModule } from "../../../../../../common/rask-common.module";
import { ChecklisteFragaAdminDTO, ChecklistGruppAdminDTO } from "../sysadm.checklista.models";
import { SysdamChecklistaService } from "../sysdam-checklista.service";

@Component({
    selector: "rask-sysadm-checklista-item",
    imports: [RaskCommonModule],
    templateUrl: "./sysadm-checklista-item.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./sysadm-checklista-item.component.scss"
})
export class SysadmChecklistaItemComponent {
    @Input() grupp: ChecklistGruppAdminDTO;
    @Output() removed = new EventEmitter<void>();
    @Output() rowClicked = new EventEmitter<ChecklisteFragaAdminDTO>();
    private readonly raskModalService = inject(RaskModalService);
    private readonly toastService = inject(ToastService);
    private readonly busyService = inject(BusyService);
    private readonly sysadmChecklistaService = inject(SysdamChecklistaService);

    protected onDeleteClick() {
        const result$ = this.raskModalService.confirm(new ModalSettings("Ta bort grupp", `Är du säker på att du vill ta bort gruppen "${this.grupp.gruppNamn}"
             och gruppens tillhörande frågor?`));

        result$.subscribe((result) => {
            if (result === ConfirmDialogResponse.cancel) {
                return;
            }

            this.deleteGrupp(this.grupp);
        });
    }

    protected onRowClick(fraga: ChecklisteFragaAdminDTO) {
        this.rowClicked.emit(fraga);
    }

    private deleteGrupp(grupp: ChecklistGruppAdminDTO) {
        this.toastService.add(`Tog bort gruppen ${grupp.gruppNamn}`);

        const response$ = this.busyService.addWork(
            this.sysadmChecklistaService.deleteChecklistGrupp(grupp.id));

        response$.subscribe(() => {
            this.removed.emit();
        });
    }
}
